import React from 'react';
import Checkbox from '../Checkbox';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import Grow from '../../decorators/Grow';
/**
 * Editable row, can be used in Table component. Contains plain cell and row elements and hidden form filled with values of each row.
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/develop/v0.3.0/components/datatable.md
 */
export default function EditableRow(_a) {
    var selectable = _a.selectable, selected = _a.selected, editable = _a.editable, open = _a.open, setOpen = _a.setOpen, cells = _a.cells, handleSelectClick = _a.handleSelectClick, Form = _a.Form;
    var keyCellPairs = Object.entries(cells);
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: "mdc-data-table__row madonna-simple-row", onClick: function () { return setOpen && setOpen(!open); } },
            selectable && (React.createElement("td", { className: "mdc-data-table__cell select-cell" },
                React.createElement(Checkbox, { checked: selected, onChange: handleSelectClick, "aria-label": "select row" }))),
            keyCellPairs.map(function (_a, index) {
                var key = _a[0], cell = _a[1];
                return (React.createElement("td", { className: "mdc-data-table__cell", key: "data-table-cell-" + index },
                    React.createElement(Tooltip, { content: (React.createElement("span", { className: "madonna-table-cell-tooltip" }, cell)), activateOn: "hover", align: "top" },
                        React.createElement(Typography, { use: "body2" }, cell))));
            })),
        editable && Form && (React.createElement("tr", { className: "mdc-data-table__row madonna-simple-row collapsible " + (open ? '' : 'collapsed') },
            React.createElement("td", { className: "mdc-data-table__cell collapsible", colSpan: keyCellPairs.length + (selectable ? 1 : 0) },
                React.createElement(Grow, { open: open, timeout: 200 },
                    React.createElement(Form, { close: function () { return setOpen && setOpen(false); }, initialValues: cells })))))));
}
//# sourceMappingURL=EditableRow.js.map